// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__TVkw5","upload":"Small_upload__EmaHv","imageWrap":"Small_imageWrap__3Sa9g","removeBtn":"Small_removeBtn__KD8vr"};